import fetch from '@/service/fetch';

export function login(params) {
  return fetch('/api/u-portal/auth/login', {
    data: params,
    method: 'POST'
  })
}

export function logout() {
  return fetch('/api/u-portal/auth/logout')
}

export function getUserInfo() {
  return fetch('/api/u-portal/auth/user');
}

export function register(params) {
  return fetch('/api/u-portal/auth/register', {
    data: params,
    method: 'POST'
  })
}

export function sendCode(params) {
  return fetch('/api/u-portal/auth/verification-code', {
    data: params,
    method: 'POST'
  })
}

export function sendResetPwdVerificationCode(params) {
  return fetch('/api/u-portal/auth/reset-pwd-verification-code', {
    data: params,
  })
}

export function resetPwd(params) {
  return fetch('/api/u-portal/auth/reset-pwd', {
    data: params,
  })
}